// Live updates without Socket.io.
// Cloudflare Workers don't hold Socket.io connections, so instead the site checks
// /api/changes every 20 seconds while the tab is open and visible, plus right away
// when you come back to the tab. When a counter changes, the matching event fires,
// so pages keep using the same calls they used with Socket.io, for example
// liveUpdates.on('orders_updated', refresh) and liveUpdates.off('orders_updated', refresh).

const POLL_MS = 20000;
const EVENTS = { orders: 'orders_updated', players: 'players_updated', teams: 'teams_updated' };

const listeners = new Map(); // event name -> Set of handlers
let lastVersions = null;
let timer = null;

const listenerCount = () => [...listeners.values()].reduce((n, set) => n + set.size, 0);

async function check() {
  if (document.visibilityState !== 'visible') return;
  try {
    const res = await fetch('/api/changes', { cache: 'no-store' });
    if (!res.ok) return;
    const versions = await res.json();
    if (lastVersions) {
      Object.entries(EVENTS).forEach(([name, event]) => {
        if (versions[name] !== lastVersions[name]) {
          (listeners.get(event) || []).forEach((handler) => handler());
        }
      });
    }
    lastVersions = versions;
  } catch {
    // Offline or a brief network error. The next check will catch up.
  }
}

const onVisible = () => {
  if (document.visibilityState === 'visible') check();
};

function start() {
  if (timer) return;
  check();
  timer = setInterval(check, POLL_MS);
  document.addEventListener('visibilitychange', onVisible);
}

function stop() {
  clearInterval(timer);
  timer = null;
  lastVersions = null;
  document.removeEventListener('visibilitychange', onVisible);
}

const liveUpdates = {
  on(event, handler) {
    if (!listeners.has(event)) listeners.set(event, new Set());
    listeners.get(event).add(handler);
    start();
  },
  off(event, handler) {
    listeners.get(event)?.delete(handler);
    if (listenerCount() === 0) stop();
  },
};

export default liveUpdates;
